(() => {
  if (customElements.get('tazty-related-products')) return;

  class TaztyRelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.automatic !== 'true' || this.loaded || this.controller) return;
      this.loadRecommendations();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    async loadRecommendations() {
      const controller = new AbortController();
      this.controller = controller;
      try {
        const response = await fetch(this.dataset.url, {
          credentials: 'same-origin',
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = await response.text();
        if (!this.isConnected || controller.signal.aborted) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const incoming = parsed.querySelector('[data-related-content]');
        const current = this.querySelector('[data-related-content]');
        // Keep collection fallback products if recommendations are empty, and
        // never remove a card that a keyboard user is currently interacting with.
        if (incoming?.dataset.recommendationsRendered === 'true' &&
            incoming.querySelector('[data-tazty-product-card]') &&
            current && !current.contains(document.activeElement)) {
          current.replaceWith(incoming);
          this.hidden = false;
          incoming.dispatchEvent(new CustomEvent('tazty:products:loaded', { bubbles: true }));
        }
        this.loaded = true;
      } catch (error) {
        // Server-rendered fallback cards remain usable on errors or offline.
        if (error.name !== 'AbortError') this.loaded = true;
      } finally {
        if (this.controller === controller) this.controller = null;
      }
    }
  }

  customElements.define('tazty-related-products', TaztyRelatedProducts);
})();
